module.exports = __webpack_public_path__ + "assets/img/5-0.9f9ffe31.svg";